import { labelStyle, groupStyle, focusStyle } from "./fieldStyles";

const TimeField = ({ formik, formClass, label, valueName, style }) => {
  return (
    <div style={{ ...groupStyle, ...style }}>
      <style>{focusStyle}</style>
      {label && <label htmlFor={valueName} style={labelStyle}>{label}</label>}
      <input
        id={valueName}
        className={`field-modern${formik.errors[valueName] ? " is-invalid" : ""}`}
        type="time"
        name={valueName}
        value={typeof formik.values[valueName] !== "undefined" ? formik.values[valueName] : "00:00"}
        onChange={formik.handleChange}
      />
      {formik.errors[valueName] && (
        <span style={{ fontSize: "0.75rem", color: "#c62828", marginTop: "3px" }}>{formik.errors[valueName]}</span>
      )}
    </div>
  );
};

export default TimeField;
